import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ModalBaseModule } from 'Angular/features/components/modals/modal-base/modal-base.module';
import { DisabledModule } from 'Angular/features/directives/disabled/disabled.module';
import { IconModule } from 'Angular/features/directives/icon/icon.module';
import { NgModelChangeDebouncedModule } from 'Angular/features/directives/ng-model-change-debounced/ng-model-change-debounced.module';
import * as i0 from "@angular/core";
export class InviteFriendModalModule {
}
InviteFriendModalModule.ɵfac = function InviteFriendModalModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || InviteFriendModalModule)(); };
InviteFriendModalModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: InviteFriendModalModule });
InviteFriendModalModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule, DisabledModule, FormsModule, ModalBaseModule, NgModelChangeDebouncedModule, IconModule] });
